module.exports = __webpack_public_path__ + "img/nav_icon_breast.0d1dd4cd.svg";